import Vue from 'vue';
import App from './App.vue';
import store  from './store/store';
import { router } from './router/router';
import { gConsts } from './globals/gConsts';
import Victor from 'victor';
import axios from 'axios';
// --- PROFILER AUTO SETUP ---
import { profilerAuto } from './mixins/profilerAuto';
import profiler from './globals/Profiler';

Object.defineProperty(Vue.prototype, '$Victor', { value: Victor });
Object.defineProperty(Vue.prototype, '$axios' , { value: axios  });    

Object.defineProperty(Vue.prototype, '$compCount', { value : {access : 0, recalc : 0, total : 0 }});

export const evtBus = new Vue();

Vue.config.devtools = true;
Vue.config.productionTip = false;
Vue.config.performance = true;
// Vue.config.warnHandler = function(msg, vm, trace) {
//     if (msg.includes('infinite update loop')) {
//           console.log('Component causing update:', vm.$options.name);
//           console.log('Current data:', vm.$data);
//           console.log('Current computed:', vm._computedWatchers);
//           console.trace('Update trace');
//     }
// }
import './mixins/tracking';



// let updateCount = 0;
// const MAX_UPDATES = 100;

// Vue.mixin({
//   beforeUpdate() {
//     updateCount++;
//     if (updateCount > MAX_UPDATES) {
//       console.warn('Excessive updates detected in component:', this.$options.name);
//       console.trace('Update stack');
//       updateCount = 0;
//     }
//   }
// });

// Replace the existing warnHandler with this more detailed version
// Vue.config.warnHandler = function(msg, vm, trace) {
//     if (msg.includes('infinite update loop')) {
//         console.group('Infinite Update Loop Detected');
//         console.log('Component:', vm.$options.name);
//         console.log('Props:', vm.$props);
//         console.log('Computed being updated:', Object.keys(vm._computedWatchers).join(', '));
//         console.log('Watchers being triggered:', Object.keys(vm._watchers).join(', '));
//         console.groupEnd();
//     }
// }

// // Modify the update counter to track per-component updates
// const updateCounts = new Map();
// const MAX_UPDATES = 20;

// Vue.mixin({
//     beforeUpdate() {
//         const componentName = this.$options.name || 'anonymous';
//         const count = (updateCounts.get(componentName) || 0) + 1;
//         updateCounts.set(componentName, count);
        
//         if (count > MAX_UPDATES) {
//             console.group(`Excessive updates in ${componentName}`);
//             console.log('Props:', this.$props);
//             console.log('Data:', this.$data);
//             console.log('Computed:', this._computedWatchers);
//             console.trace('Update stack');
//             console.groupEnd();
//             updateCounts.clear();
//         }
//     }
// });



const vueOptions = {
    store,
    render: h => h(App)
}
var mountDIV, initParams,
    radioBot_htmlElem = document.getElementById('radioBot');

if (radioBot_htmlElem) {  // Embedded component
    mountDIV = '#radioBot';
    initParams = JSON.parse(radioBot_htmlElem.getAttribute('initParams'));

    vueOptions.data = {
        isEmbedded : true,
        initParams : initParams
    }
} else {  // SPA (with login and routing)
    mountDIV = '#app';
    vueOptions.data = {
        isEmbedded : false,
        initParams : null
    }
    vueOptions['router'] = router;
}

// Global error handler
// Vue.config.errorHandler = function(err, vm, info) {
//     console.error('Error:', err);
//     console.error('Component:', vm);
//     console.error('Info:', info);
//     console.trace();
// };

const app = new Vue(vueOptions).$mount(mountDIV);

// --- COMMENT OUT MANUAL PROFILER ---
// profiler.start('AppSession');
// profiler.end();
// profiler.printSummary();
// profiler.reset();

// Re-enabled with safer implementation
profiler.disableProfiler();
profiler.start('AppSession');
// enableAutomaticProfiling(Vue, store);
// Attach Vue lifecycle logging to profiler
// profiler.attachVueLifecycleLogging(Vue);

// Add global lifecycle logging for all components
// Vue.mixin({
//   created() {
//     if (this.$options.name) {
//       console.debug(`[LIFECYCLE] created: ${this.$options.name} (id: ${this._uid})`);
//     }
//   },
//   mounted() {
//     if (this.$options.name) {
//       console.debug(`[LIFECYCLE] mounted: ${this.$options.name} (id: ${this._uid})`);
//     }
//   },
//   updated() {
//     if (this.$options.name) {
//       console.debug(`[LIFECYCLE] updated: ${this.$options.name} (id: ${this._uid})`);
//     }
//   },
//   destroyed() {
//     if (this.$options.name) {
//       console.debug(`[LIFECYCLE] destroyed: ${this.$options.name} (id: ${this._uid})`);
//     }
//   }
// });

// Add profiler mixin globally
Vue.mixin(profilerAuto.mixin);
// Add profiler plugin to Vuex store
// profilerAuto.vuex(store);
